import * as React from 'react'

import PaginationWrapper from './components/PaginationWrapper/PaginationWrapper'

interface Props {
  total: number
  page: number
  perPage: number
  onPagination: (page: number, perPage: number) => void
  perPageOptions?: Array<number>
  hidePerPage?: boolean
  hideNextButton?: boolean
  hidePrevButton?: boolean
  showFirstButton?: boolean
  showLastButton?: boolean
  boundaryCount?: number
  defaultPage?: number
  siblingCount?: number
}

const Pagination = ({
  total,
  page,
  perPage,
  onPagination,
  perPageOptions = [5, 10, 15, 25, 50, 100],
  hidePerPage = false,
  hideNextButton = false,
  hidePrevButton = false,
  showFirstButton = true,
  showLastButton = true,
  boundaryCount = 1,
  siblingCount = 1,
  defaultPage = 1
}: Props) => {
  const handleChange = (
    _: React.MouseEvent,
    newPage: number | null,
    itemsPerPage?: number
  ): void => {
    onPagination(newPage ?? 1, itemsPerPage ?? perPage)
  }

  const handlePerPageChange = (next: number) => {
    onPagination(1, next)
  }

  const pages = Math.ceil(total / perPage)

  return (
    <div className="flex w-full justify-center">
      <PaginationWrapper
        count={pages}
        disabled={pages <= 1}
        onChange={handleChange}
        onPerPageChange={handlePerPageChange}
        page={page}
        perPage={perPage}
        boundaryCount={boundaryCount}
        defaultPage={defaultPage}
        hideNextButton={hideNextButton}
        hidePrevButton={hidePrevButton}
        showFirstButton={showFirstButton}
        showLastButton={showLastButton}
        siblingCount={siblingCount}
        perPageOptions={perPageOptions}
        hidePerPage={hidePerPage}
      />
    </div>
  )
}

export default Pagination
